import { Component, ViewChild } from '@angular/core';
import { environment } from 'environments/environment';
import { Logger } from './../../core/logger.service';
import { SignupComponent } from 'app/shared/signup/signup.component';
import * as Models from 'app/core/models';

const log = new Logger('App');
@Component({
    selector: 'app-signup-modal',
    templateUrl: './signupModal.component.html',
    styleUrls: ['./signupModal.component.scss']
})

export class SignupModalComponent implements Models.ModalComponent {

    @ViewChild('modalSignup') public contentModal: any;
    @ViewChild(SignupComponent) public signupComponent: SignupComponent;

    version: string = environment.version;
    error: any = null;
    isLoading = false;

    constructor() {
    }

    SuccessAction() {}


    openModal() {
        this.signupComponent.reset();
        this.contentModal.show();
    }

    closeModal() {
        this.contentModal.hide();
    }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/signup/signupModal.component.ts